import { Injectable } from '@angular/core';
import { AppMenuItem } from './app-menu-item';
import { AppMenu } from './app-menu';
import { PermissionCheckerService } from '@abp/auth/permission-checker.service';

@Injectable()
export class AppNavigationService {
    constructor(private _permissionService: PermissionCheckerService) {}

    getMenu(): AppMenu {
        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem('Calendar', '', 'flaticon-calendar-3', '/app/main/scheduling-calendar'),
            new AppMenuItem('Six-Four-Two', '', 'flaticon-calendar-1', '/app/main/six-four-two'),
            new AppMenuItem('Auto Scheduling', '', 'la la-random', '/app/smart-scheduling'),
            new AppMenuItem('Booking Lists', null, 'la la-list', '/app/booking-lists'),
            new AppMenuItem('PTL', null, 'flaticon-list-3', '/app/patient-tracking-list'),
            new AppMenuItem('Improvement Programmes', '', 'flaticon-squares-3', '/app/improvement-programs/'),
            new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-list-3', '/app/admin/tenants'),
            new AppMenuItem('Editions', 'Pages.Editions', 'flaticon-app', '/app/admin/editions'),
            new AppMenuItem('Administration', '', 'flaticon-interface-8', '', [
                new AppMenuItem(
                    'OrganizationUnits',
                    'Pages.Administration.OrganizationUnits',
                    'flaticon-map',
                    '/app/admin/organization-units'
                ),
                new AppMenuItem('Roles', 'Pages.Administration.Roles', 'flaticon-suitcase', '/app/admin/roles'),
                new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
                new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', '/app/admin/languages'),
                new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', '/app/admin/auditLogs'),
                new AppMenuItem('Maintenance', 'Pages.Administration.Host.Maintenance', 'flaticon-lock', '/app/admin/maintenance'),
                new AppMenuItem(
                    'Subscription',
                    'Pages.Administration.Tenant.SubscriptionManagement',
                    'flaticon-refresh',
                    '/app/admin/subscription-management'
                ),
                new AppMenuItem(
                    'Field Mappings',
                    'Pages.Administration.Tenant.Settings',
                    'flaticon-interface-4',
                    '/app/admin/field-mappings'
                ),
                new AppMenuItem(
                    'VisualSettings',
                    'Pages.Administration.UiCustomization',
                    'flaticon-medical',
                    '/app/admin/ui-customization'
                ),
                new AppMenuItem('Data Quality Report', 'Pages.Administration.Users', 'flaticon-danger', '/app/admin/dataQualityReport'),
                new AppMenuItem('Settings', 'Pages.Administration.Host.Settings', 'flaticon-settings', '/app/admin/hostSettings'),
                new AppMenuItem('Settings', 'Pages.Administration.Tenant.Settings', 'flaticon-settings', '/app/admin/tenantSettings')
            ])
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName && this._permissionService.isGranted(subMenuItem.permissionName)) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                return this.checkChildMenuItemPermission(subMenuItem);
            } else if (!subMenuItem.permissionName) {
                return true;
            }
        }

        return false;
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/layout/nav/app-navigation.service.ts